import { render, staticRenderFns } from "./ModalDataLost.vue?vue&type=template&id=401cce14&scoped=true&"
import script from "./ModalDataLost.vue?vue&type=script&lang=js&"
export * from "./ModalDataLost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401cce14",
  null
  
)

export default component.exports